import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import NavButtons from 'components/Advanced_User/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import PrimaryBox from 'components/Advanced_User/All_BlueIris_Tutorials/PrimaryBox';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  PrimaryBox,
  React
};